/**
 * Product Signup Form Variant Tracking with Availability Toggle
 * Updates the selected variant in the product signup form when variants change
 * Shows/hides the form and heading based on variant availability
 */

class ProductSignupVariantTracker {
  constructor() {
    this.init();
  }

  init() {
    this.signupForm = this.findSignupForm();
    if (!this.signupForm) {
      console.log('Product signup form not found');
      return;
    }

    this.variantInput = this.signupForm.querySelector('#product-signup-variant');
    this.variantIdInput = this.signupForm.querySelector('#product-signup-variant-id');

    if (!this.variantInput || !this.variantIdInput) {
      console.log('Variant inputs not found in signup form');
      return;
    }

    // Heading container
    this.signupHeading = this.signupForm.closest('.product-info__block').querySelector('.product-signup-heading');

    // Store original display for the form
    this.originalDisplay = this.signupForm.style.display || getComputedStyle(this.signupForm).display;
    if (this.originalDisplay === 'none') {
      this.originalDisplay = 'block';
    }

    // Ensure correct state on load
    this.checkInitialVariantState();

    // Listen for variant change events
    this.bindEvents();
  }

  findSignupForm() {
    const variantInput = document.querySelector('#product-signup-variant');
    if (variantInput) {
      return variantInput.closest('form');
    }
    return null;
  }

  bindEvents() {
    document.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
  }

  isVariantAvailable(variant) {
    if (typeof variant.available === 'boolean') {
      return variant.available;
    }
    if (typeof variant.inventory_quantity === 'number') {
      if (variant.inventory_management === 'shopify') {
        return variant.inventory_quantity > 0 || variant.inventory_policy === 'continue';
      }
      return variant.inventory_quantity > 0;
    }
    if (variant.inventory_policy === 'continue') {
      return true;
    }
    return false;
  }

  showFormAndHeading() {
    this.signupForm.style.display = this.originalDisplay;
    if (this.signupHeading) {
      this.signupHeading.style.display = 'block';
    }
  }

  hideFormAndHeading() {
    this.signupForm.style.display = 'none';
    if (this.signupHeading) {
      this.signupHeading.style.display = 'none';
    }
  }

  checkInitialVariantState() {
    // Try to read data-variant JSON if the theme provides it
    const initialVariantData = window.product && window.product.selected_or_first_available_variant;
    if (initialVariantData) {
      this.updateState(initialVariantData);
    }
  }

  handleVariantChange(evt) {
    if (!evt.detail || !evt.detail.variant) return;
    this.updateState(evt.detail.variant);
  }

  updateState(variant) {
    const isAvailable = this.isVariantAvailable(variant);

    this.variantInput.value = variant.title || '';
    this.variantIdInput.value = variant.id || '';

    if (isAvailable) {
      this.hideFormAndHeading();
    } else {
      this.showFormAndHeading();
    }
  }
}

// Init
document.addEventListener('DOMContentLoaded', () => {
  new ProductSignupVariantTracker();
});
